var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComboBundleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 6,
    fill: "#E6E6E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.1081 38.3714L50.6298 29.944C52.4567 28.7143 52.4567 26.2856 50.6298 25.056L38.1081 16.6285C36.8628 15.7905 35.1372 15.7905 33.892 16.6285L21.3703 25.056C19.5432 26.2856 19.5432 28.7143 21.3703 29.944L33.892 38.3714C35.1372 39.2095 36.8628 39.2095 38.1081 38.3714Z",
    fill: "#4D4D4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1047 34.3256C50.7503 33.8913 51.645 33.8915 52.2904 34.3261C53.2365 34.9631 53.2365 36.2207 52.2904 36.8579L38.2036 46.3428C36.9022 47.2191 35.0979 47.2191 33.7965 46.3428L19.7097 36.8579C18.7634 36.2207 18.7634 34.9631 19.7097 34.3261C19.7904 34.2717 19.8749 34.2242 19.9624 34.1835C20.5749 33.8982 21.3305 33.9457 21.8954 34.3256L36 43.8151L50.1047 34.3256Z",
    fill: "#4D4D4D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1047 42.3256C50.7503 41.8913 51.645 41.8915 52.2904 42.3261C53.2365 42.9631 53.2365 44.2207 52.2904 44.8579L38.2036 54.3428C36.9022 55.2191 35.0979 55.2191 33.7965 54.3428L19.7097 44.8579C18.7634 44.2207 18.7634 42.9631 19.7097 42.3261C19.7904 42.2717 19.8749 42.2242 19.9624 42.1835C20.5749 41.8982 21.3305 41.9457 21.8954 42.3256L36 51.8151L50.1047 42.3256Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComboBundleIcon);
export default __webpack_public_path__ + "static/media/combo-bundle-icon.bd3d855badf73c5e3183cf762c88bb98.svg";
export { ForwardRef as ReactComponent };